import type { editor } from 'monaco-editor';

export const setupMonacoEditorOnMount = (
    monacoEditor: editor.IStandaloneCodeEditor,
    onFocus: () => void,
    onBlur: () => void,
    focusOnInsert: boolean = false,
) => {
    // Focus the editor when it is mounted only if the node should be focused on insert
    if (focusOnInsert) {
        monacoEditor.focus();
    }

    monacoEditor.onDidFocusEditorText(() => {
        onFocus();
    });

    monacoEditor.onDidBlurEditorText(() => {
        onBlur();
    });
};
